import { sendJsonRequest, sendXHRRequest, sendRawRequest } from "./utils";
import { isEmail, validateRequirements } from "../utils/validations";

/**
 *
 * @param {object} data {email: string;}
 */
export const requestResetPassword = (data) => {
    if (!isEmail(data.email)) {
        return Promise.reject(["Please enter a valid email"]);
    }

    return sendJsonRequest("/core/users/password_reset/", "POST", data);
};

const defaultSignupParams = {
    logic_without_pass: false,
    enable_random_name: true,
};
/**
 *
 * @param {object} data
 * {
 *    title: string,
 *    email: string,
 *    password: string,
 *    logic_without_pass: boolean,
 *    enable_random_name: boolean
 *  }
 * @return {Promise}
 */
export const signup = (data) => {
    const errors = validateRequirements(data, {
        email: { validation: isEmail, message: "Please enter a valid email" },
        password: "missing password",
        title: "missing a name",
    });
    if (errors.length > 0) {
        return Promise.reject(errors);
    }
    const payload = { ...defaultSignupParams, ...data };

    return sendXHRRequest("/core/setup/signup/", "POST", JSON.stringify(payload)).catch((error) => {
        const errorMessage = error ? error.error : undefined;
        throw errorMessage ? [errorMessage] : error;
    });
};

export const updateSite = (data) => {
    const errors = validateRequirements(data, {
        id: "missing site id",
        name: "missing site name",
        title: "missing site title",
    });
    if (errors.length > 0) {
        return Promise.reject(errors);
    }

    return sendJsonRequest(`/core/feeds/site/${data.id}`, "PUT", data);
};

export const uploadAvatar = (formData) => {
    return sendRawRequest("/core/feeds/avatar", "POST", formData);
};
